import React, { Component } from "react";
import moment from "moment-timezone";
import store from "../../../redux/store";
import { ValidatorForm } from "react-material-ui-form-validator";
import { withRouter } from "../../../withRouter";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import { UpdateSchedulingDate_Url } from "../../../provider/ServiceUrl";
import FetchServerData from "../../../provider/FetchServerData";
import SaveButton from "../buttons/SaveButton";
import CancelIconButton from "../buttons/CancelIconButton";
// import Utils from "../../../provider/Utils";
import ReminderTimer from "../reminderTimer/ReminderTimer";
import PtsDateTimePicker from "../ptsDateTime/PtsDateTimePicker";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

class ScheduledSend extends Component {
  header = store.getState().header.header;
  orgTimeZone = store.getState().appUserData?.organizationDetails?.timezone;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  eventTimeZone = store.getState().businessDomain?.eventTimeZone

  breadCrumb = [
    { pageid: "/scheduledSends", uiname: "Scheduled Sends" },
    { pageid: "", uiname: "Edit Scheduled Send" },
  ];

  constructor(props) {
    super(props);
    let action = props.action;
    let messageName = props.messageName;
    let messageLogId = props.messageLogId;
    let scheduledDateTime = props.scheduledDateTime;
    if (!action && props.state) {
      action = props.state.action;
      messageLogId = props.state.messageLogId;
      messageName = props.state.messageName;
      scheduledDateTime = props.state.scheduledDateTime;
    }
    this.state = {
      messageName: messageName,
      scheduledDateTime: scheduledDateTime,
      messageLogId: messageLogId,
      initialPage: 0,
      pageSize: 10,
      render: false,
    };
  }

  handleScheduledDateTimeChange(date) {
    this.setState({
      render: true,
      scheduledDateTime: date?.dateTime,
      scheduleErrorMessage: false,
    });
  }

  updateSchedulingDate() {
    const postObject = {
      header: this.header,
      messageLog: {
        id: this.state.messageLogId,
        scheduledDate: moment(this.state.scheduledDateTime).format(
          "yyyy-MM-DDTHH:mm:ss.SSS"
        ),
      },
    };
    FetchServerData.callPostService(UpdateSchedulingDate_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          //   let smsMessage = output.data.smsMessage;
          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            this.props.navigate("/eventScheduledSends");
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            this.props.navigate("/dptextScheduledSends");
          } else {
            this.props.navigate("/scheduledSends");
          }
        } else {
        }
      })
      .catch((error) => { });
  }

  editCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventScheduledSends");
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextScheduledSends");
    } else {
      this.props.navigate("/scheduledSends");
    }
  }

  navigateOrgTimeZone() {
    store.dispatch(SelectedTabAction.setSelectedTab(0));
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    this.props.navigate("/settings");
  }

  render() {
    let startDate = "";
    // let viewStartDate = "";
    if (this.state.scheduledDateTime !== undefined) {
      startDate = this.state.scheduledDateTime;
      // let now = new Date(startDate);
      // viewStartDate = Utils.convertUTCDateToUserTimeZoneViewDateFormate(now);
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name="Edit Scheduled Send"
        />
        <div className="row">
          <div className="col-md-12">
            <div className="card" id="giveBeeCard">
              <div className="card-body">
                <ValidatorForm
                  className="text-start"
                  ref="form"
                  onSubmit={this.updateSchedulingDate.bind(this)}
                >
                  <div className="row">
                    <div className="col-md-8">
                      <div className="row">
                        <label
                          className="col-sm-2 col-form-label"
                          htmlFor="basic-default-supplierType"
                          id="assetFormLabel"
                        >
                          Message name
                        </label>
                        <div className="col-sm-10" id="givbeeText">
                          <span>{this.state.messageName}</span>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <label
                          className="col-sm-2 col-form-label"
                          htmlFor="multiStepsLastName"
                        >
                          Send date/time
                        </label>
                        <div className="col-sm-6 m-0" id="givbeeText">
                          <PtsDateTimePicker
                            value={this.state.scheduledDateTime}
                            onChange={this.handleScheduledDateTimeChange.bind(
                              this
                            )}
                            pageId="ScheduledSend"
                          />
                        </div>
                        <div className="col-sm-4 align-self-center ps-2">
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#337AB7",
                              fontWeight: "600",
                              fontSize: "12px",
                            }}
                            onClick={this.navigateOrgTimeZone.bind(this)}
                          >
                            {this.businessDomain === BUSINESS_DOMAIN.eventText ? this.eventTimeZone?.displayText : this.orgTimeZone?.displayText}
                          </span>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <label
                          className="col-sm-2 col-form-label"
                          htmlFor="basic-default-supplierType"
                          id="assetFormLabel"
                        >
                          Countdown
                        </label>
                        <div className="col-sm-10" id="givbeeText">
                          <span>
                            <ReminderTimer startDate={startDate} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4 d-flex align-items-center justify-content-between">
                    <div className="col-sm-12 mt-3 text-center">
                      <SaveButton btnName="Create" type="submit" />
                      &nbsp;&nbsp;
                      <CancelIconButton onClick={(e) => this.editCancel()} />
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(ScheduledSend);
